module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/tipper-active.199f4f18.svg";